// src/pages/CoursesPage.jsx
import React, { useEffect, useState } from "react";
import StaffSidebar from "../components/StaffSidebar";
import axios from "axios";
import Pagination from "../components/Pagination"; // you can move the Pagination helper into its own file
import "../assets/css/staff-dashboard.css"; // reuses the same styles

export default function CoursesPage() {
  const programme = localStorage.getItem("programme");
  const API = process.env.REACT_APP_API_BASE_URL || "http://localhost:3003";
  const PAGE_SIZE = 12;
  const LEVELS = [
    "All",
    "ND1",
    "ND2",
    "HND1",
    "HND2",
    // "Postgraduate",
    // "Diploma",
  ];

  const [courses, setCourses] = useState([]);
  const [courseSearch, setCourseSearch] = useState("");
  const [courseLevel, setCourseLevel] = useState("All");
  const [coursePage, setCoursePage] = useState(1);

  // Fetch courses whenever filters change
  useEffect(() => {
    if (!programme) return;
    axios
      .get(`${API}/api/staff/courses`, {
        params: {
          programme,
          level: courseLevel === "All" ? "" : courseLevel,
          search: courseSearch.trim(),
        },
      })
      .then((res) => {
        setCourses(res.data);
        setCoursePage(1);
      })
      .catch((err) => {
        console.error("Failed to fetch courses:", err);
      });
  }, [API, programme, courseLevel, courseSearch]);

  // Pagination logic
  const totalPages = Math.ceil(courses.length / PAGE_SIZE);
  const pagedCourses = courses.slice(
    (coursePage - 1) * PAGE_SIZE,
    coursePage * PAGE_SIZE
  );

  return (
    <div className="staff-dashboard" style={{ marginTop: "-130px" }}>
      <StaffSidebar />

      <main>
        <h1>Courses</h1>

        <section className="panel">
          {/* Filters */}
          <div className="controls">
            <input
              type="search"
              placeholder="Search courses…"
              value={courseSearch}
              onChange={(e) => setCourseSearch(e.target.value)}
            />
            <select
              value={courseLevel}
              onChange={(e) => setCourseLevel(e.target.value)}
            >
              {LEVELS.map((lvl) => (
                <option key={lvl} value={lvl}>
                  {lvl}
                </option>
              ))}
            </select>
          </div>

          {/* Courses Table */}
          <table className="table modern">
            <thead>
              <tr>
                <th>Code</th>
                <th>Title</th>
                <th>Level</th>
                <th>Units</th>
              </tr>
            </thead>
            <tbody>
              {pagedCourses.map((c) => (
                <tr key={c.CourseID}>
                  <td>{c.CourseCode}</td>
                  <td>{c.CourseTitle}</td>
                  <td>{c.Level}</td>
                  <td>{c.CreditUnits ?? "-"}</td>
                </tr>
              ))}
              {pagedCourses.length === 0 && (
                <tr>
                  <td
                    colSpan={4}
                    style={{ textAlign: "center", padding: "1rem" }}
                  >
                    No courses found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <Pagination
            page={coursePage}
            total={totalPages}
            onChange={setCoursePage}
          />
        </section>
      </main>
    </div>
  );
}
